import { Fragment } from 'react';

import { TbWorld } from 'react-icons/tb';
import { FaChevronDown, FaWhatsapp } from 'react-icons/fa';

import Logo from 'assets/images/logo.svg';
import { Button } from 'components/base';
import { Menu, Transition } from '@headlessui/react';
import { useLanguageContext } from 'components/context/LanguageContext';
import useTranslation from 'hooks/useTranslation';

interface NavbarProps {
  className?: string;
}

const WhatsAppLink = () => {
  const phoneNumber = '+41796970821';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;
  window.open(whatsappUrl);
};

const Navbar = ({ className }: NavbarProps) => {
  const { language, changeLanguage } = useLanguageContext();
  const translation = useTranslation();

  return (
    <div
      className={`fixed z-50 flex w-full items-center justify-between bg-white p-4 lg:px-[64px] ${className}`}
    >
      <div className="flex items-center lg:w-full lg:justify-between">
        <div className="flex items-center">
          <a href="/" onClick={() => window.location.href = '/'}>
            <img
              alt="websnap"
              src={Logo}
              className="h-6 w-[107px] lg:h-8 lg:w-[143px]"
            />
          </a>
          <button className="ml-[60px] hidden text-base font-medium text-primary-grey lg:block">
            {/*translation.whatWeDo*/}
          </button>
          <button className="ml-9 hidden text-base font-medium text-primary-grey lg:block">
            {/*translation.pricing*/}
          </button>
          <button className="ml-9 hidden text-base font-medium text-primary-grey lg:block">
            {/*translation.order*/}
          </button>
        </div>
      </div>
      <div className="flex items-center">
        <div className="">
          <Menu as="div" className="relative inline-block text-left">
            <Menu.Button className="ml-4 flex items-center">
              <TbWorld className="h-5 w-5 lg:h-6 lg:w-6" />
              <p className="ml-0.5 text-sm font-medium uppercase lg:text-base">
                {language}
              </p>
              <FaChevronDown className="ml-2.5 h-3 w-3" />
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className="absolute right-0 mt-4 w-[120px] origin-top-right rounded-2xl bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <Menu.Item
                  onClick={() => changeLanguage('en')}
                  as="button"
                  className="w-full rounded-t-2xl px-5 py-3 text-left"
                >
                  <p className="text-sm text-primary-black">English</p>
                </Menu.Item>
                <div className="border-t" />
                <Menu.Item
                  onClick={() => changeLanguage('de')}
                  as="button"
                  className="w-full px-5 py-3 text-left"
                >
                  <p className="text-sm text-primary-black">German</p>
                </Menu.Item>
                <div className="border-t" />
                <Menu.Item
                  onClick={() => changeLanguage('fr')}
                  as="button"
                  className="w-full px-5 py-3 text-left"
                >
                  <p className="text-sm text-primary-black">French</p>
                </Menu.Item>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
        {/* <button className="ml-4 flex items-center" onClick={handleDialog}>
          <TbWorld className="h-5 w-5 lg:h-6 lg:w-6" />
          <p className="ml-0.5 text-sm font-medium uppercase lg:text-base">
            {language}
          </p>
          <FaChevronDown className="ml-2.5 h-3 w-3" />
        </button> */}
        <Button
          onClick={WhatsAppLink}
          theme="OUTLINE"
          className="ml-[30px] hidden items-center whitespace-nowrap border-primary-light-blue !py-3 !px-4 lg:flex"
        >
          <FaWhatsapp className="h-5 w-5 text-primary-light-blue" />
          <p className="ml-2.5 text-sm font-semibold text-primary-light-blue">
            {translation.needHelp}
          </p>
        </Button>
      </div>
    </div>
  );
};

export default Navbar;
